/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Services Icon component.
 */
export const SideNavServicesIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_803_21741)">
        <path d="M5.75625 14.999L3.10714 18.3639C3.03774 18.4521 3 18.561 3 18.6732V21.2C3 21.6774 3.23705 22.1352 3.65901 22.4728C4.08097 22.8104 4.65326 23 5.25 23H18.75C19.3467 23 19.919 22.8104 20.341 22.4728C20.7629 22.1352 21 21.6774 21 21.2V18.6732C21 18.561 20.9623 18.4521 20.8929 18.3639L18.2437 14.999C18.0575 14.6991 17.7703 14.4467 17.4146 14.2703C17.0588 14.0938 16.6486 14.0002 16.23 14H7.77C7.35141 14.0002 6.94117 14.0938 6.58543 14.2703C6.22968 14.4467 5.94252 14.6991 5.75625 14.999Z" stroke={iconColor} strokeWidth="1.5" strokeMiterlimit="10"/>
        <path d="M21 19H3" stroke={iconColor} strokeWidth="1.5" strokeMiterlimit="10"/>
        <path d="M6 21H6.01" stroke={iconColor} strokeWidth="1.5" strokeMiterlimit="10"/>
        <path d="M10 21H10.01" stroke={iconColor} strokeWidth="1.5" strokeMiterlimit="10"/>
        <path d="M5.4999 6H1.1499C0.87376 6 0.649902 6.22386 0.649902 6.5V11.5C0.649902 11.7761 0.87376 12 1.1499 12H5.4999C5.77604 12 5.9999 11.7761 5.9999 11.5V6.5C5.9999 6.22386 5.77604 6 5.4999 6Z" stroke={iconColor} strokeWidth="1.5"/>
        <path d="M22.85 6H18.5C18.2239 6 18 6.22386 18 6.5V11.5C18 11.7761 18.2239 12 18.5 12H22.85C23.1261 12 23.35 11.7761 23.35 11.5V6.5C23.35 6.22386 23.1261 6 22.85 6Z" stroke={iconColor} strokeWidth="1.5"/>
        <path d="M5.5 9H7C8.10457 9 9 9.89543 9 11V14" stroke={iconColor} strokeWidth="1.5"/>
        <path d="M18.5 9H17C15.8954 9 15 9.89543 15 11V14" stroke={iconColor} strokeWidth="1.5"/>
        <path d="M12 14V7" stroke={iconColor} strokeWidth="1.5"/>
        <path d="M11.9285 6.99957C13.6249 6.99959 15.0001 5.62442 15.0001 3.92805C15 2.23168 13.6249 0.856488 11.9285 0.856473C10.2321 0.856458 8.85695 2.23162 8.85696 3.928C8.85698 5.62437 10.2322 6.99956 11.9285 6.99957Z" stroke={iconColor} strokeWidth="1.5"/>
      </g>
      <defs>
        <clipPath id="clip0_803_21741">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};
